/*
 * <video-text-player> — sections/section-video-text.liquid
 *
 * Wraps Dawn's <deferred-media> click-to-play element. YouTube switches to its
 * Shorts-style player for vertical embeds, and that player loops. This listens to the
 * player's state messages (YouTube IFrame API postMessage protocol, no extra script
 * needed) and pauses + rewinds when the video ends, so it plays once and stops.
 */
if (!customElements.get('video-text-player')) {
  customElements.define(
    'video-text-player',
    class VideoTextPlayer extends HTMLElement {
      constructor() {
        super();
        this.onMessage = this.onMessage.bind(this);
        this.bindIframe = this.bindIframe.bind(this);
      }

      connectedCallback() {
        // The iframe only exists after the visitor clicks the poster; watch for it.
        this.observer = new MutationObserver(this.bindIframe);
        this.observer.observe(this, { childList: true, subtree: true });
        window.addEventListener('message', this.onMessage);
        this.bindIframe();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('message', this.onMessage);
        this.iframe = null;
      }

      bindIframe() {
        const iframe = this.querySelector('iframe.js-youtube');
        if (!iframe || iframe === this.iframe) return;
        this.iframe = iframe;
        // YouTube only sends state events after it receives a "listening" handshake.
        iframe.addEventListener('load', () => this.post({ event: 'listening' }));
      }

      post(message) {
        if (!this.iframe || !this.iframe.contentWindow) return;
        this.iframe.contentWindow.postMessage(JSON.stringify(message), 'https://www.youtube.com');
      }

      onMessage(event) {
        if (event.origin !== 'https://www.youtube.com') return;
        if (!this.iframe || event.source !== this.iframe.contentWindow) return;

        let data;
        try {
          data = JSON.parse(event.data);
        } catch (error) {
          return;
        }

        // Player state 0 = ended (reported either way depending on player version)
        const ended =
          (data.event === 'onStateChange' && data.info === 0) ||
          (data.event === 'infoDelivery' && data.info && data.info.playerState === 0);

        if (ended) {
          this.post({ event: 'command', func: 'pauseVideo', args: [] });
          this.post({ event: 'command', func: 'seekTo', args: [0, true] });
        }
      }
    }
  );
}
